import React from 'react'

const Notfound = () => {
  return (
    <div>
      <h1>jhsdljs</h1>
    </div>
  )
}

export default Notfound
